//Reference: EN117

import { Mappeable } from './mappeable.model';
import moment from 'moment';
import * as _ from 'lodash';

export class EstimateExchange extends Mappeable {
    idTypePredictionChangePk: number;
    currency: any;
    mrkActive: number;
    nmrChange: number;
    nmrExerciese: number;
    nmrExercieseApply: number;
    txtoTypePrediction: string;

    constructor(o) {
        super(o);
        this.nmrExerciese = moment().year();
        //this.mrkActive = this.mrkActive ??  0 
        this.mrkActive = 1;
        this.txtoTypePrediction = "-";
    }

    public mapToBack() {
        return {
            idTypePredictionChangePk: this.idTypePredictionChangePk,
            mrkActive: this.mrkActive,
            nmrExercieseApply: this.nmrExercieseApply,
            nmrExerciese: this.nmrExerciese,
            nmrChange: this.nmrChange,
            txtoTypePrediction: this.txtoTypePrediction,
            currency: this.currency
        }
    }
}